<template>
  <transition name="slide-up">
    <div class="dialog" v-if="visible">
      <div class="dialog__content"
           :style="style">
        <div class="dialog__content__header">
          <font-awesome-icon :icon="['fal','times']"
                             class="dialog__content__header__close"
                             @click="closeModal"/>
          <slot name="header">
          </slot>
        </div>
        <div class="dialog__content__body">
          <slot></slot>
        </div>
        <div class="dialog__content__footer">
          <slot name="footer">
            <button class="dialog__content__footer__close"
                    @click="closeModal"
            >
              {{ $t('base.close') }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
  },
  computed: {
    isInventoryRoute() {
      return this.$store.getters['routeStore/childRoute'] === 'inventory';
    },
    isMobile() {
      return this.$store.getters['dimensionStore/isMobile'];
    },
    style() {
      if (this.isMobile) return {};
      return { width: this.width, height: this.height };
    },
  },
  methods: {
    closeModal() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style scoped lang="scss">
  .slide-up-enter-active, .slide-up-leave-active {
    transition: margin-top 0.4s;
    @include breakpoint(mobileWithHeight) {
      transition: opacity 0.4s;
    }
  }
  .slide-up-enter, .slide-up-leave-to {
    margin-top: 100vh;
    @include breakpoint(mobileWithHeight) {
      margin-top: 0;
      opacity: 0;
    }
  }
  .slide-up-enter-to, .slide-up-leave {
    margin-top: 0;
    @include breakpoint(mobileWithHeight) {
      opacity: 1;
    }
  }
  .dialog{
    display: block;
    background-color: transparent;
    height: calc(100% - 52px);
    width: 100%;
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 52px;
    @include breakpoint(mobileWithHeight){
      top: 0;
      height: 100%;
      background-color: $--next-dark-blue-light-opacity-60;
    }
    &.--fit-content {
      .dialog__content {
        width: fit-content;
        width: -moz-fit-content;
      }
    }
    &__content{
      display: grid;
      background-color: white;
      border-radius: $--border-radius-base;
      padding: 0 12px;
      grid-template-rows: 12px auto 1fr auto 12px;
      grid-template-areas: "."
                           "header"
                           "body"
                           "footer"
                           ".";
      margin: 0;
      width: 100%;
      height: 100%;
      @include breakpoint(mobileWithHeight){
        height: auto;
        max-height: 80vh;
        width: 80vw;
        padding: 0 20px;
        grid-template-rows: 20px auto 1fr auto 20px;
        position: relative;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
      }
      @include breakpoint(desktop){
        width: 800px;
      }

      &__header{
        grid-area: header;
        margin-bottom: 10px;
        display: block;
        &__close{
          float: right;
          &:hover {
            cursor: pointer;
          }
        }
        @include breakpoint(mobileWithHeight){
          margin-bottom: 20px;
        }
      }
      &__body{
        grid-area: body;
        overflow: auto;
      }
      &__footer{
        grid-area: footer;
        width: 100%;
        text-align: center;
        &__close{
          margin-top: 10px;
          height: 42px;
          width: 160px;
          font-size: 16px;
          cursor: pointer;
          background-color: $--next-light-grey-blue;
          border-radius: $--border-radius-base;
          border: none;
          @include breakpoint(mobileWithHeight){
            margin-top: 20px;
          }
        }
      }
    }
  }
</style>
